
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRank6 as ObiRank6Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-rank-6.js';
 
 
 

 
 export const ObiRank6 = createComponent({
   react: React,
   tagName: 'obi-rank-6',
   elementClass: ObiRank6Element,
   events: {
     
   }
  });
 
 